var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-root" },
    [
      _c("h1", [_vm._v("作废协议")]),
      _vm._l(_vm.INVALI.signInfoVOS, function(signator, i) {
        return _c("p", { key: signator.i }, [
          _vm._v(
            _vm._s(
              "签约方" +
                _vm.simpleChineseNumbers[i + 1] +
                ":  " +
                (signator.signatoryFullName.split("-")[0] || "")
            )
          )
        ])
      }),
      _c("p", { staticClass: "indent" }, [
        _vm._v(
          "鉴于以上签约方于" +
            _vm._s(
              _vm
                .moment(_vm.INVALI.applyCreateTime || _vm.INVALI.createTime)
                .format("YYYY年MM月DD日")
            ) +
            "签订了主题名为《" +
            _vm._s(_vm.INVALI.contractName) +
            "》的合同（以下简称“原合同”），合同编号为：" +
            _vm._s(_vm.INVALI.applyNo) +
            "。现经签约各方协商一致，同意终止原合同并达成如下协议："
        )
      ]),
      _c("h2", [_vm._v("第一条 合同作废声明")]),
      _c("p", { staticClass: "indent" }, [
        _vm._v(
          "以上签约方确认，自本协议签署之日起，原合同效力终止，签约各方权利义务关系解除，原合同不再对签约各方具有法律约束力。"
        )
      ]),
      _c("h2", [_vm._v("第二条 作废原因")]),
      _c("p", { staticClass: "indent" }, [
        _vm._v(
          "同意作废原合同的原因：" +
            _vm._s(
              _vm.cancelForm.reason
                ? _vm.reasonSet.find(function(item) {
                    return item.value === _vm.cancelForm.reason
                  }).label
                : ""
            ) +
            "。"
        )
      ]),
      _c("p", { staticClass: "indent line-break" }, [
        _vm._v("详细说明：" + _vm._s(_vm.cancelForm.reasontxt) + "。")
      ]),
      _c("h2", [_vm._v("第三条 其他")]),
      _c("p", { staticClass: "indent" }, [
        _vm._v("1.本协议自签约各方签字或盖章之日起生效；")
      ]),
      _c("p", { staticClass: "indent" }, [
        _vm._v("2.未尽事宜，签约各方可另行签订补充协议。")
      ]),
      _vm._l(_vm.INVALI.signInfoVOS, function(signator, i) {
        return _c("p", { key: signator.signNo }, [
          _vm._v(
            _vm._s(
              "签约方" +
                _vm.simpleChineseNumbers[i + 1] +
                ":  " +
                (signator.signatoryFullName.split("-")[0] || "")
            )
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7969f078", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7969f078","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/invalidation/components/contract.vue
// module id = xwcw
// module chunks = 100 226